// import hooks
import { useCallback } from "react";
import useEventListener from "../../hooks/useEventListener/index.js";
import useGetPlatform from "../../hooks/usePlatform/index.js";
import { MAC } from "../../constants/platform.consts.js";
export const useKeyPress = ({ char, payload, withCommandKey, disabled }) => {
    const platform = useGetPlatform();
    const handler = useCallback((event) => {
        const isCommandKeyPressed = platform === MAC ? !!event?.metaKey : !!event?.ctrlKey;
        const firePayload = event?.key === char && (withCommandKey ? isCommandKeyPressed : true);
        if (firePayload) {
            event?.stopPropagation();
            event?.preventDefault();
            payload();
        }
    }, [char, payload, withCommandKey, platform]);
    useEventListener({
        eventName: "keydown",
        payload: handler,
        options: {
            disabled,
        },
    });
};
export default useKeyPress;
